.notice {
  margin: 0;
  max-width: 42rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--warning);
  border-radius: 0.5rem;
  background: var(--warning-surface);
  color: var(--warning-text);
}

.link {
  color: inherit;
  font-weight: 600;
}
